import { Outlet, createFileRoute } from '@tanstack/react-router';
import { AdminOnly } from '@/component/AdminOnly';
import { ErrorState } from '@/component/ErrorState';

export const Route = createFileRoute('/_app/admin')({ component: AdminRoute });

function AdminRoute() {
  return (
    <AdminOnly fallback={<ErrorState message="Admin access required." />}>
      <Outlet />
    </AdminOnly>
  );
}
